import { teacherNeedsOnboarding } from "./teacherOnboarding";
import { isBursarUser, isLibrarianUser } from "./staffRoles";

export const teacherPostLoginPath = (user) => {
    if ((isBursarUser(user) || isLibrarianUser(user)) && teacherNeedsOnboarding(user)) return "/Teacher/dashboard";
    if (teacherNeedsOnboarding(user)) return "/Teacher/profile";
    return "/Teacher/dashboard";
};
